import React from 'react';
import styled from 'styled-components';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
const DrawerDiv = styled.div`
    overflow: visible;
    position: fixed;
    ${props =>
        (props.position.toLowerCase().includes('left') ? 'left:0' : null)};
    ${props =>
        (props.position.toLowerCase().includes('right') ? 'right:0' : null)};
    ${props =>
        (props.position.toLowerCase().includes('top') ? 'top: 10vh' : null)};
    ${props =>
        (props.position.toLowerCase().includes('bottom') ? 'bottom:0' : null)};
    width: ${props =>
        (typeof props.width === 'number' ? `${props.width}px` : props.width)};
    // height:100%;
    z-index: 9;
    background-color: initial;
    pointer-events: none;
`;

// 内容
// height: ${props =>
//     (typeof props.height === 'number' ? `${props.height}px` : props.height)};
const DrawerContent = styled.div`
    position: relative;
    max-height: 100%;
    width: 100%;
    display: flex;
    z-index: 8;
    pointer-events: none;
    box-sizing: content-box;
    // height: 74vh;
    transform: ${props => props.transform};
    transition: transform 0.5s ease-in-out;
`;

const WrapDrawerContent = styled.div`
    box-shadow: 0px 25px 42px 0px rgb(0 0 0 / 8%);
    display: flex;
    width: 100%;
    max-height: 546px;
    position: relative;
    flex-direction: column;
    justify-content: stretch;
    overflow: hidden;
    border-top-left-radius: 31px;
    border-bottom-left-radius: 31px;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    border: 1px solid #e9e9e9;
    border-right: none;
    background-color: #fff;
    pointer-events: all;
`;

class DrawerComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['renderContentCOntainer', 'renderDragHandle']);
    }
    // 渲染内容框
    renderContentCOntainer (props) {
        return (
            <DrawerContent
                height={this.props.height}
                {...props}
                {...this.props.contentProps}
            >
                {this.renderDragHandle()}
                <WrapDrawerContent>{this.props.children}</WrapDrawerContent>
            </DrawerContent>
        );
    }

    // 渲染手柄
    renderDragHandle () {
        const {renderDragHandle} = this.props;
        const defaultHandle = <></>;
        return renderDragHandle ? renderDragHandle() : defaultHandle;
    }

    render () {
        return (
            <DrawerDiv
                // id="drawer"
                style={this.props.drawStyles}
                width={this.props.width}
                position={this.props.position}
            >
                {this.renderContentCOntainer({
                    transform: this.props.isShow ?
                        'translateX(0)' :
                        `translateX(${this.props.width}px)`
                })}
            </DrawerDiv>
        );
    }
}
DrawerComponent.propTypes = {
    position: PropTypes.oneOf([
        'top',
        'bottom',
        'left',
        'right',
        'topRight',
        'topLeft',
        'bottomLeft',
        'bottomRight'
    ]), // 抽屉位置
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // 抽屉高度
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // 抽屉宽度
    // eslint-disable-next-line react/forbid-prop-types
    drawStyles: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    contentProps: PropTypes.object,
    isShow: PropTypes.bool,
    children: PropTypes.element,
    renderDragHandle: PropTypes.func
};

DrawerComponent.defaultProps = {
    position: 'topRight',
    // height: ,
    width: 270
};


export {DrawerComponent};
